import React, { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import { Grid, Box, Card, Avatar, Typography, Divider, Button } from '@mui/material';
import GradientButton from "../Button";
// import Avatarimg from './Avatarimg.png';


const Temp4 = ({ data }) => {
    const componentRef = useRef();
    const handlePrint = useReactToPrint({
        contentRef: componentRef,
    });

    return (
        <>
            <div ref={componentRef}>
                <Grid container ref={componentRef} sx={{ display: 'flex', justifyContent: 'center' }} >
                    <Grid size={{ xs: 12, lg: 10 }} margin={'2%'} border='1px solid black' padding='2% 2% 2% 2%' >
                        <Grid container size={{ xs: 12 }} >
                            <Grid size={{ xs: 5, lg: 5 }}>
                                <Box sx={{ backgroundColor: '#253439' }}>
                                    <Box sx={{ height: '20px' }}></Box>
                                    <Box sx={{ display: 'flex', justifyContent: 'center', }}>
                                        <Avatar sx={{ height: 180, width: 180 }} src={data.imageUrl} />
                                    </Box>
                                    <Box sx={{ backgroundColor: '#595551', padding: '8%', marginTop: '5%' }}>
                                        <Typography sx={{ fontFamily: 'Nunito', fontSize: '44px', fontWeight: '700', color: 'rgb(255, 255, 255)' }}>
                                            {data.fname}
                                        </Typography>
                                        <Typography sx={{ fontFamily: 'Nunito', fontSize: '44px', fontWeight: '700', color: 'rgb(255, 255, 255)', marginTop: '-5%' }}>
                                            {data.lname}
                                        </Typography>
                                        <Typography sx={{ fontFamily: 'Nunito', fontSize: '18px', fontWeight: '400', color: 'rgb(255, 255, 255)', marginTop: '2%' }}>
                                            {data.headline}
                                        </Typography>
                                    </Box>
                                    <Box sx={{ padding: '6%' }}>
                                        <Typography sx={{ fontFamily: 'Nunito', fontSize: '18px', fontWeight: '700', color: 'rgb(255, 255, 255)', letterSpacing: '0.15em' }}>
                                            ABOUT
                                        </Typography>
                                        <Typography sx={{ fontFamily: 'Nunito', fontSize: '14px', fontWeight: '400', color: 'rgb(255, 255, 255)', marginTop: '6%' }}>
                                            {data.summary}
                                        </Typography><Typography sx={{ fontFamily: 'Nunito', fontSize: '18px', fontWeight: '700', color: 'rgb(255, 255, 255)', marginTop: '10%', letterSpacing: '0.15em' }}>
                                            CONTACT
                                        </Typography>
                                        <Box>
                                            <Typography sx={{ fontFamily: 'Nunito', fontSize: '16px', fontWeight: '400', color: 'rgb(255, 255, 255)', marginTop: '6%' }}>
                                                {data.email}<br />{data.city}<br />{data.country}
                                            </Typography>
                                        </Box>
                                        <Typography sx={{ fontFamily: 'Nunito', fontSize: '18px', fontWeight: '700', color: 'rgb(255, 255, 255)', marginTop: '10%', letterSpacing: '0.15em' }}>
                                            LANGUAGES
                                        </Typography>
                                        <Box>
                                            {data.languageArr?.map((item2) => {
                                                return (
                                                    <Typography sx={{ fontFamily: 'Nunito', fontSize: '16px', fontWeight: '400', color: 'rgb(255, 255, 255)', marginTop: '6%' }}>
                                                        {item2.title} <i>({item2.Emptyp})</i>
                                                    </Typography>
                                                );
                                            })}
                                        </Box>
                                        <Typography sx={{ fontFamily: 'Nunito', fontSize: '18px', fontWeight: '700', color: 'rgb(255, 255, 255)', marginTop: '10%', letterSpacing: '0.15em' }}>
                                            SKILLS
                                        </Typography>
                                        <Box>
                                            {data.SkillArr?.map((item1) => {
                                                return (
                                                    <Typography sx={{ fontFamily: 'Nunito', fontSize: '16px', fontWeight: '400', color: 'rgb(255, 255, 255)', marginTop: '6%' }}>
                                                        {item1.title} <i>({item1.Emptyp})</i>
                                                    </Typography>
                                                );
                                            })}
                                        </Box>
                                        <Typography sx={{ fontFamily: 'Nunito', fontSize: '18px', fontWeight: '700', color: 'rgb(255, 255, 255)', marginTop: '10%', letterSpacing: '0.15em' }}>
                                            HOBBIES
                                        </Typography>
                                        <Box>
                                            {data.hobbies?.map((item4) => {
                                                return (
                                                    <Typography sx={{ fontFamily: 'Nunito', fontSize: '16px', fontWeight: '400', color: 'rgb(255, 255, 255)', marginTop: '6%' }}>
                                                        {item4.title}
                                                    </Typography>
                                                );
                                            })}
                                        </Box>
                                    </Box>
                                    <Box sx={{ height: '80px' }}></Box>
                                </Box>
                            </Grid>
                            <Grid size={{ xs: 7, lg: 7 }} sx={{ borderLeft: '2px solid black', paddingLeft: '4%' }}>
                                <Typography sx={{ fontFamily: 'Nunito', fontSize: '20px', fontWeight: '1000', marginTop: '4%', letterSpacing: '0.15em', textAlign: 'end', color: '#595551' }}>RESUME</Typography>
                                <Divider />
                                <Box sx={{ padding: '8%' }}>
                                    <Typography sx={{ fontFamily: 'Nunito', fontSize: '18px', fontWeight: 'bold', letterSpacing: '0.25em', color: '#595551', textDecoration: 'underline' }}>
                                        EXPERIENCE
                                    </Typography>
                                    {data.workArray?.map((item5) => {
                                        return (
                                            <Box>
                                                <Box component="span" sx={{ display: 'inline-block', mx: '8px', transform: 'scale(4)', color: '#595551', marginTop: '2%' }}>
                                                    •
                                                </Box>
                                                <Typography sx={{ fontFamily: 'Nunito', fontSize: '18px', fontWeight: '600', marginTop: '2%' }}>
                                                    {item5.designation} at {item5.company}
                                                </Typography>
                                                <Typography sx={{ fontFamily: 'Nunito', fontSize: '15px', fontWeight: '500' }}>
                                                    ({item5.start}) - ({item5.end})
                                                </Typography>
                                                <Typography sx={{ fontFamily: 'Nunito', fontSize: '16px', fontWeight: '600', marginTop: '1%' }}>
                                                    ({item5.location})
                                                </Typography>
                                                <Typography sx={{ fontFamily: 'Nunito', fontSize: '16px', fontWeight: '600', marginTop: '1%' }}>
                                                    {item5.employmentType}
                                                </Typography>
                                            </Box>
                                        );
                                    })}
                                    <Typography sx={{ fontFamily: 'Nunito', fontSize: '18px', fontWeight: '1000', letterSpacing: '0.15em', marginTop: '6%', color: '#595551', textDecoration: 'underline' }}>
                                        EDUCATION
                                    </Typography>
                                    {data.educationArr?.map((item6) => {
                                        return (
                                            <Box>
                                                <Box component="span" sx={{ display: 'inline-block', mx: '8px', transform: 'scale(4)', color: '#595551', marginTop: '2%' }}>
                                                    •
                                                </Box>
                                                <Typography sx={{ fontFamily: 'Nunito', fontSize: '18px', fontWeight: '600', marginTop: '2%' }}>
                                                    {item6.course} in {item6.special}
                                                </Typography>
                                                <Typography sx={{ fontFamily: 'Nunito', fontSize: '15px', fontWeight: '500' }}>
                                                    ({item6.start}) - ({item6.end})
                                                </Typography>
                                                <Typography sx={{ fontFamily: 'Nunito', fontSize: '16px', fontWeight: '600', marginTop: '1%' }}>
                                                    {item6.inst}
                                                </Typography>
                                                <Typography sx={{ fontFamily: 'Nunito', fontSize: '15px', fontWeight: '500', marginTop: '1%' }}>
                                                    <span style={{ fontWeight: '600', fontSize: '16px' }}>CGPA -</span> {item6.grade}
                                                </Typography>
                                            </Box>
                                        );
                                    })}
                                    <Typography sx={{ fontFamily: 'Nunito', fontSize: '18px', fontWeight: '1000', letterSpacing: '0.15em', marginTop: '6%', color: '#595551', textDecoration: 'underline' }}>
                                        TRAINING AND CERTIFICATES
                                    </Typography>
                                    {data.trainingArr?.map((item7) => {
                                        return (
                                            <Box>
                                                <Box component="span" sx={{ display: 'inline-block', mx: '8px', transform: 'scale(4)', color: '#595551', marginTop: '2%' }}>
                                                    •
                                                </Box>
                                                <Typography sx={{ fontFamily: 'Nunito', fontSize: '18px', fontWeight: '600', marginTop: '2%' }}>
                                                    {item7.title} from {item7.organization}
                                                </Typography>
                                                <Typography sx={{ fontFamily: 'Nunito', fontSize: '15px', fontWeight: '500' }}>
                                                    ({item7.start}) - ({item7.end})
                                                </Typography>
                                                <Typography sx={{ fontFamily: 'Nunito', fontSize: '16px', fontWeight: '600', marginTop: '1%' }}>
                                                    {item7.description}
                                                </Typography>
                                            </Box>
                                        );
                                    })}
                                    <Typography sx={{ fontFamily: 'Nunito', fontSize: '18px', fontWeight: '1000', letterSpacing: '0.15em', marginTop: '6%', color: '#595551', textDecoration: 'underline' }}>
                                        ACHIEVEMENTS
                                    </Typography>
                                    {data.achivementsArr?.map((item8) => {
                                        return (
                                            <Box>
                                                <Box component="span" sx={{ display: 'inline-block', mx: '8px', transform: 'scale(4)', color: '#595551', marginTop: '2%' }}>
                                                    •
                                                </Box>
                                                <Typography sx={{ fontFamily: 'Nunito', fontSize: '18px', fontWeight: '600', marginTop: '2%' }}>
                                                    {item8.title}
                                                </Typography>
                                                <Typography sx={{ fontFamily: 'Nunito', fontSize: '15px', fontWeight: '500' }}>
                                                    ({item8.start})
                                                </Typography>
                                                <Typography sx={{ fontFamily: 'Nunito', fontSize: '16px', fontWeight: '600', marginTop: '1%' }}>
                                                    {item8.description}
                                                </Typography>
                                            </Box>
                                        );
                                    })}
                                </Box>
                            </Grid>
                            <Grid size={{ xs: 0.5, lg: 0.5 }}></Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </div>
            <Grid sx={{ display: 'flex', justifyContent: 'center' }}>
                <GradientButton id="download" variant="contained" onClick={handlePrint} sx={{ marginTop: '20px', margin: 'auto' }}>Download PDF</GradientButton>	</Grid>
        </>
    )
}

export default Temp4